/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { ZonePrimary } from "../../models/zone-primary";
import { ZoneSecondary } from "../../models/zone-secondary";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ReadZone$Params {
  organisation_id: string;
  zone_id: string;
}

export function readZone(
  http: HttpClient,
  rootUrl: string,
  params: ReadZone$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ZonePrimary | ZoneSecondary>> {
  const rb = new RequestBuilder(rootUrl, readZone.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("zone_id", params.zone_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ZonePrimary | ZoneSecondary>;
    }),
  );
}

readZone.PATH = "/surfdomeinen/organisations/{organisation_id}/zones/{zone_id}";
